import { render, staticRenderFns } from "./WarehouseDetails.vue?vue&type=template&id=0b4f4ba0&scoped=true&"
import script from "./WarehouseDetails.vue?vue&type=script&lang=js&"
export * from "./WarehouseDetails.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseDetails.vue?vue&type=style&index=0&id=0b4f4ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4f4ba0",
  null
  
)

component.options.__file = "WarehouseDetails.vue"
export default component.exports